import { URI } from '@/config/config';

export default async ({rootState}, payload ) => {
  const url = new URL(`${URI}control-panel/employee/delete-photo-request`)
  const opts = {
    method: 'DELETE',
    body:JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    }
  }

  const photoRequest = await fetch(url, opts)
  const jsonResult = await photoRequest.json() 
  if(jsonResult.status !=='success'){
    return Promise.reject(jsonResult.message)
  }
  if (jsonResult.error) {
    return Promise.reject(jsonResult.error)
  }
}
